export enum RoleType {
  guest = 1,
  unverified = 50,
  user = 100,
  admin = 200,
}
